import type { ReactElement } from "react";
import { useRef } from "react";

import { CSSTransition, SwitchTransition } from "react-transition-group";

import { SwLogoItem } from "@similarweb/ui-components";

import { swSettings } from "app/common/services/swSettings";
import { translate } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import { SIWizardSmallLogoUrl } from "app/pages/sales-intelligence/constants/images";
import { WizardStep } from "app/pages/sales-intelligence/sub-modules/onboarding/types/WizardStepType";

import {
    StyledAnimatedDescription,
    StyledSITitleText,
    StyledWelcomeText,
    StyledWizardDescription,
    StyledWizardGreetingText,
    StyledWizardLeftPartContainer,
    StyledWizardSwLogoItem,
} from "./styles";

const SI_LOGO_SEPARATOR = "%siLogoPlace%";

interface Props {
    currentStep: WizardStep;
}

const WizardLeftPartContainer = ({ currentStep }: Props): ReactElement => {
    const welcomeTitle = translate("si.onboarding.wizard.welcome-to-text").split(SI_LOGO_SEPARATOR);

    const description =
        currentStep === WizardStep.Focus ? "si.onboarding.wizard.description" : "si.onboarding.wizard.description2";
    const nodeRef = useRef(null);

    return (
        <StyledWizardLeftPartContainer>
            <StyledWizardSwLogoItem>
                <SwLogoItem
                    isCollapsed={false}
                    iconName="similar-icon"
                />
            </StyledWizardSwLogoItem>

            <StyledWelcomeText>
                <span dangerouslySetInnerHTML={{ __html: welcomeTitle[0] }} />

                <img src={SIWizardSmallLogoUrl} />

                <StyledSITitleText dangerouslySetInnerHTML={{ __html: welcomeTitle[1] }} />
            </StyledWelcomeText>

            <I18n
                translatable={{
                    key: "si.onboarding.wizard.greeting-text",
                    replacements: {
                        firstName: swSettings.user.firstname,
                    },
                }}
                element={StyledWizardGreetingText}
            />

            <SwitchTransition>
                <CSSTransition
                    key={description}
                    in
                    mountOnEnter={false}
                    timeout={500}
                    classNames="item"
                    nodeRef={nodeRef}
                >
                    <StyledAnimatedDescription ref={nodeRef}>
                        <I18n
                            translatable={{ key: description }}
                            element={StyledWizardDescription}
                        />
                    </StyledAnimatedDescription>
                </CSSTransition>
            </SwitchTransition>
        </StyledWizardLeftPartContainer>
    );
};

export default WizardLeftPartContainer;
